import apiInstance from '../../../../../api';
import {call, put} from 'redux-saga/effects';
import {
  //Kitchen Contracts
  sendRequestKitchenContractsGetSuccess,
  sendRequestKitchenContractsGetError,
  setKitchenContracts,
  sendRequestKitchenContractsCreateSuccess,
  sendRequestKitchenContractsCreateError,
  sendRequestKitchenContractsUpdateSuccess,
  sendRequestKitchenContractsUpdateError,
  sendRequestKitchenContractsDeleteSuccess,
  sendRequestKitchenContractsDeleteError,

  //Kitchen Contract Commissions
  sendRequestKitchenContractCommissionsGetSuccess,
  sendRequestKitchenContractCommissionsGetError,
  setKitchenContractCommissions,
  sendRequestKitchenContractCommissionsCreateSuccess,
  sendRequestKitchenContractCommissionsCreateError,
  sendRequestKitchenContractCommissionsUpdateSuccess,
  sendRequestKitchenContractCommissionsUpdateError,
  sendRequestKitchenContractCommissionsDeleteSuccess,
  sendRequestKitchenContractCommissionsDeleteError,
} from '../../../../reducers/utils/kitchenReducers/kitchenSettingsReducer';

//Kitchen Contracts
export function* handleGetKitchenContracts(action) {
  const api = '/kitchen/contract/get?XDEBUG_SESSION_START=MyVSCode';
  const data = action.payload;

  try {
    const response = yield call(() => apiInstance.post(api, JSON.stringify({ data })));

    if (response.data.result) {
      const modifyData = response.data.data.contracts.map((item) => ({ ...item, key: item.id }))

      yield put(sendRequestKitchenContractsGetSuccess());
      yield put(setKitchenContracts(modifyData));
    } else {
      yield put(sendRequestKitchenContractsGetError());
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    
    yield put(sendRequestKitchenContractsGetError());
  }
}

export function* handleCreateKitchenContracts(action) {
  const api = '/kitchen/contract/create?XDEBUG_SESSION_START=MyVSCode';
  const data = action.payload;

  try {
    const response = yield call(() => apiInstance.post(api, JSON.stringify({ data })));

    if (response.data.result) {
      yield put(sendRequestKitchenContractsCreateSuccess());
    } else {
      yield put(sendRequestKitchenContractsCreateError());
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    
    yield put(sendRequestKitchenContractsCreateError());
  }
}

export function* handleUpdateKitchenContracts(action) {
  const api = '/kitchen/contract/update?XDEBUG_SESSION_START=MyVSCode';
  const data = action.payload;

  try {
    const response = yield call(() => apiInstance.post(api, JSON.stringify({ data })));

    if (response.data.result) {
      yield put(sendRequestKitchenContractsUpdateSuccess());
    } else {
      yield put(sendRequestKitchenContractsUpdateError());
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    
    yield put(sendRequestKitchenContractsUpdateError());
  }
}

export function* handleDeleteKitchenContracts(action) {
  const api = '/kitchen/contract/delete?XDEBUG_SESSION_START=MyVSCode';
  const data = action.payload;

  try {
    const response = yield call(() => apiInstance.post(api, JSON.stringify({ data })));

    if (response.data.result) {
      yield put(sendRequestKitchenContractsDeleteSuccess());
    } else {
      yield put(sendRequestKitchenContractsDeleteError());
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    
    yield put(sendRequestKitchenContractsDeleteError());
  }
}

//Kitchen Contract Commissions
export function* handleGetKitchenContractCommissions(action) {
  const api = '/kitchen/commission/get?XDEBUG_SESSION_START=MyVSCode';
  const data = action.payload;

  try {
    const response = yield call(() => apiInstance.post(api, JSON.stringify({ data })));

    if (response.data.result) {
      yield put(sendRequestKitchenContractCommissionsGetSuccess());
      yield put(setKitchenContractCommissions(response.data.data));
    } else {
      yield put(sendRequestKitchenContractCommissionsGetError());
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    
    yield put(sendRequestKitchenContractCommissionsGetError());
  }
}

export function* handleCreateKitchenContractCommissions(action) {
  const api = '/kitchen/commission/create?XDEBUG_SESSION_START=MyVSCode';
  const data = action.payload;

  try {
    const response = yield call(() => apiInstance.post(api, JSON.stringify({ data })));

    if (response.data.result) {
      yield put(sendRequestKitchenContractCommissionsCreateSuccess());
    } else {
      yield put(sendRequestKitchenContractCommissionsCreateError());
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    
    yield put(sendRequestKitchenContractCommissionsCreateError());
  }
}

export function* handleUpdateKitchenContractCommissions(action) {
  const api = '/kitchen/commission/update?XDEBUG_SESSION_START=MyVSCode';
  const data = action.payload;

  try {
    const response = yield call(() => apiInstance.post(api, JSON.stringify({ data })));

    if (response.data.result) {
      yield put(sendRequestKitchenContractCommissionsUpdateSuccess());
    } else {
      yield put(sendRequestKitchenContractCommissionsUpdateError());
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    
    yield put(sendRequestKitchenContractCommissionsUpdateError());
  }
}

export function* handleDeleteKitchenContractCommissions(action) {
  const api = '/kitchen/commission/delete?XDEBUG_SESSION_START=MyVSCode';
  const data = action.payload;

  try {
    const response = yield call(() => apiInstance.post(api, JSON.stringify({ data })));

    if (response.data.result) {
      yield put(sendRequestKitchenContractCommissionsDeleteSuccess());
    } else {
      yield put(sendRequestKitchenContractCommissionsDeleteError());
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    
    yield put(sendRequestKitchenContractCommissionsDeleteError());
  }
}
